import { BaseErrorHero } from "./BaseErrorHero";

export const ForbiddenHero = () => {
  return <BaseErrorHero hero="wrong way!" description="You do not have access to this resource" />;
};
